import {
  Tabs as MaterialTabs,
  TabsHeader,
  Tab,
} from '@material-tailwind/react';
import React, { useEffect, useState } from 'react';
import Shops from '../../../components/shop/shops';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

import '../../../styles/shop/shop.css';
import { PageContainer } from '../../../components/layout/page/PageContainer';
import TextWinds from '../../../components/common/TextWinds';
import { useAppDispatch, useAppSelector } from '../../../store/hook';
import {
  getShopLists,
  resetShopInfo,
  resetShopLists,
  selectShopLists,
} from '../../../store/features/shopSlice';
import { CommonResProps, ShopInfoProps } from '../../../constants/types';
import {
  AppProductListOrderBy,
  ProductSubType,
  ProductType,
} from '../../../enum';
import { Link } from 'react-router-dom';
import useUserHook from '../../../hooks/useUserHook';

const TABS_MENU = [
  {
    label: '전체',
    value: 'ALL',
  },
  {
    label: '일반 도서',
    value: ProductSubType.NORMAL_BOOK,
  },
  {
    label: '굿즈(교구)',
    value: ProductSubType.GOODS,
  },
  // {
  //     label: "최근 본 상품",
  //     value: "HISTORY",
  // },
];

const Shop = () => {
  const { checkAndPageMove } = useUserHook();
  const dispatch = useAppDispatch();
  const [activeTab, setActiveTab] = useState('ALL');

  useEffect(() => {
    dispatch(resetShopLists());
    // dispatch(resetShopInfo())
    tabClickHandler(activeTab);
  }, []);

  const shopLists = useAppSelector(selectShopLists);

  const params = {
    product_type: ProductType.STANDARD,
    product_sub_type: ProductSubType.ALL,
    order_by: AppProductListOrderBy.RECOMMENDED,
  };

  const tabClickHandler = (value: string) => {
    setActiveTab(value);
    dispatch(
      getShopLists({
        url: '/v1/product',
        params: { ...params, product_sub_type: value },
      }),
    );
  };

  return (
    <PageContainer>
      <section>
        <MaterialTabs value={activeTab} className="relative border-b">
          <TabsHeader
            className="inline-flex rounded-none bg-transparent bg-white p-0"
            indicatorProps={{
              className:
                'bg-transparent border-b-2 border-purple5 shadow-none rounded-none  ',
            }}
          >
            {TABS_MENU.map(({ label, value }) => (
              <Tab
                key={value}
                value={value}
                onClick={() => tabClickHandler(value)}
                className={`ml-[24px] h-[48px] whitespace-nowrap text-content_bold ${
                  activeTab === value ? 'text-purple5' : ''
                }`}
              >
                {label}
              </Tab>
            ))}
          </TabsHeader>
        </MaterialTabs>
      </section>

      <section className="px-0 pt-[24px]">
        <div className="mx-4 my-2 grid grid-cols-2 gap-x-[15px] gap-y-[24px] lg:grid-cols-4">
          {shopLists && (
            <Shops
              activeTab={activeTab}
              label={activeTab}
              datas={shopLists as CommonResProps<ShopInfoProps[]>}
            />
          )}
        </div>
      </section>

      <section className="mt-[80px] pb-6">
        <div className="xl:py[50px] relative flex w-full items-center justify-between rounded-none bg-gradient-to-r from-gradient_f2 to-gradient_t2 px-[20px] py-[26px] xl:mb-[100px] xl:justify-between xl:bg-spotLilac xl:from-transparent xl:to-transparent xl:px-[72px]">
          <div className="relative inline-flex hidden flex-auto flex-col items-start xl:block">
            <TextWinds type="title_h1" color="white">
              젭스의 전체 코스
            </TextWinds>
            <TextWinds type="content_body1" color="white" className="pt-[10px]">
              영어교실부터 주일학교, NIV학습까지!
              <br />
              나에게 필요한 젭스 코스가 무엇인지 확인해 보세요.
            </TextWinds>
          </div>
          <div className="relative inline-flex w-full flex-col items-end justify-end gap-[20px] xl:w-[390px]">
            <div className="relative flex flex-auto items-start justify-between self-stretch rounded-md bg-white px-[12px] py-[14px] xl:p-[24px]">
              <div className="relative">
                <Link to={'/courses'}>
                  <TextWinds type="content_bold">
                    학습 코스를 수강하기 원하시나요?
                  </TextWinds>
                  <div className="gap-[2px]] inline-flex flex-auto items-center">
                    <TextWinds type="content_bold" color="purple5">
                      코스 찾기 이동
                    </TextWinds>
                    <ArrowRightIcon
                      className="h-[20px] w-[20px]"
                      color="purple"
                    />
                  </div>
                </Link>
              </div>
              <Link to={'/courses'}>
                <img
                  className="relative h-[52px] w-[52px]"
                  alt=""
                  src={process.env.PUBLIC_URL + 'images/shop/boosterup.png'}
                />
              </Link>
            </div>
            <div
              className="relative flex flex-auto cursor-pointer items-start justify-between self-stretch rounded-md bg-white px-[12px] py-[14px] xl:p-[24px]"
              onClick={() => {
                checkAndPageMove('/ClassManagement');
              }}
            >
              <div className="relative">
                <TextWinds type="content_bold">
                  내 클래스와 관련된 상품을 구매하시나요?
                </TextWinds>
                <div className="gap-[2px]] inline-flex flex-auto items-center">
                  <TextWinds type="content_bold" color="purple5">
                    부스트업 이동
                  </TextWinds>
                  <ArrowRightIcon
                    className="h-[20px] w-[20px]"
                    color="purple"
                  />
                </div>
              </div>
              <img
                className="!relative !h-[52px] !w-[52px]"
                alt=""
                src={process.env.PUBLIC_URL + 'images/shop/findshop.png'}
              />
            </div>
          </div>
        </div>
      </section>
    </PageContainer>
  );
};

export default Shop;
